import * as _firebase from "firebase/app";
import "firebase/analytics";

const firebase = _firebase.default;
export default class {
  private defaultAnalytics: _firebase.default.analytics.Analytics;
  constructor() {
    this.defaultAnalytics = firebase.analytics();
  }

  logEvent(name: string, params: { [key: string]: any }) {
    this.defaultAnalytics.logEvent(name, params);
  }

  logError(params: { [key: string]: any }) {
    this.defaultAnalytics.logEvent(
      firebase.analytics.EventName.EXCEPTION,
      params
    );
  }

  setUserProperties(params: { [key: string]: any }) {
    this.defaultAnalytics.setUserProperties(params);
  }
}
